export const materialTypeOptins = [
    {
        label: "M01电子件",
        value: 'M01',
        example: '电脑主机、显示器、电源适配器、电机、电源线等',
    },
    {
        label: "M02机械标准件",
        value: 'M02',
        example: '丝杆、铝件、散热模块等',
    },
    {
        label: "M03结构件",
        value: 'M03',
        example: '机加工件、外壳、胶垫、橡胶减震块等',
    },
    {
        label: "M04光学类",
        value: 'M04',
        example: '镜头、光纤、激光光源、滤光片等',
    },
    {
        label: "M05软件类",
        value: 'M05',
        example: '应用软件、调试软件等',
    },
    {
        label: "M06纸质品类",
        value: 'M06',
        example: '说明书、标签等',
    },
    {
        label: "M07包材",
        value: 'M07',
        example: '木箱、保利龙、纸箱等',
    },
    {
        label: "M08辅料",
        value: 'M08',
        example: '胶布、扎带、胶水、螺丝、螺母、垫片、弹簧、键、销轴等等.',
    },
    {
        label: "M09配件",
        value: 'M09',
        example: '扫码枪、升降台、肩带、腕带、打印机等',
    },
    {
        label: "半成品",
        value: null
    },
];


export const semiFinishedProductOptions = [
    {
        label: "天鸽",
        value: "P0101",
    },
    {
        label: "天鹅600",
        value: "P0201",
    },
    {
        label: "天鹅600P",
        value: "P0202",
    },
    {
        label: "天鹅700",
        value: "P0301",
    },
    {
        label: "天鹅700P",
        value: "P0302",
    },
    {
        label: "天龙800",
        value: "P0401",
    },
    {
        label: "天龙800P",
        value: "P0402",
    },
    {
        label: "天龙900",
        value: "P0501",
    },
    {
        label: "天龙900P",
        value: "P0502",
    },
    {
        label: "天鹤700",
        value: "P0601",
    },
    {
        label: "星豚",
        value: "P0701",
    },
    {
        label: "水星",
        value: "P0801",
    },
    {
        label: "天猫",
        value: "P0901",
    },
    {
        label: "天鹿600",
        value: "P1001",
    },
    {
        label: "天鹿700",
        value: "P1101",
    },
    {
        label: "天狼",
        value: "P1201",
    },
    {
        label: "天鹰600",
        value: "P1301",
    },
    {
        label: "天鹰700",
        value: "P1401",
    },
];

export const materialOptions = [
    {
        value: "OP",
        label: "光学件OP",
        children: [
            {
                label: "镜片JP",
                value: "JP",
            },
            {
                label: "镜头JT",
                value: "JT",
            },
            {
                label: "透镜LE",
                value: "LE",
            },
            {
                label: "光源IL",
                value: "IL",
            },
            {
                label: "相机CA",
                value: "CA",
            },
            {
                label: "耦合器CP",
                value: "CP",
            },
            {
                label: "光电元件OE",
                value: "OE",
            },
            {
                label: "光机结构件OS",
                value: "OS",
            },
        ],
    },
    {
        value: "ST",
        label: "结构件ST",
        children: [
            {
                label: "光轴OA",
                value: "OA",
            },
            {
                label: "轴承BE",
                value: "BE",
            },
            {
                label: "按键帽BC",
                value: "BC",
            },
            {
                label: "弹簧SP",
                value: "SP"
            },
            {
                label: "包材PM",
                value: "PM"
            },
            {
                label: "减震SA",
                value: "SA"
            },
            {
                label: "防护网PS",
                value: "PS"
            },
            {
                label: "线束WH",
                value: "WH"
            },
            {
                label: "导轨DG",
                value: "DG"
            },
            {
                label: "丝杆SG",
                value: "SG"
            },
            {
                label: "垫圈DQ",
                value: "DQ"
            },
            {
                label: "散热SR",
                value: "SR"
            },
            {
                label: "其他QT",
                value: "QT"
            }
        ],
    },
    {
        label: "电子件EL",
        value: "EL",
        children: [
            {
                label: "按键BU",
                value: "BU",
            },
            {
                label: "触发开关TS",
                value: "TS",
            },
            {
                label: "液晶屏LCD",
                value: "LCD",
            },
            {
                label: "触摸屏CTP",
                value: "CTP",
            },
            {
                label: "主机HC",
                value: "HC",
            },
            {
                label: "探测器DE",
                value: "DE",
            },
            {
                label: "电机MO",
                value: "MO",
            },
            {
                label: "风扇EF",
                value: "EF",
            },
            {
                label: "线缆XL",
                value: "XL",
            },
            {
                label: "驱动HD",
                value: "HD",
            },
            {
                label: "连接器CR",
                value: "CR",
            }, {
                label: "音频AD",
                value: "AD"
            }, {
                label: "数据采集器DA",
                value: "DA"
            }, {
                label: "电池BAT",
                value: "BAT"
            }
        ],
    },
];



export const getMaterialCodeByType = (type) => {
    // const numberReg = /^\d+(\.\d+)?$/;

    // if (numberReg.test(type)) {
    //     return "M"
    // }
    // return "P"
    return type
}
